import { AxiosRequestConfig } from 'axios';
import RpcMethod from 'services/rpc/rpcMethod';
import { getRpcParams } from 'services/rpc/rpcUtils';
import IBusyRpcWrapper from 'types/BusyRpcWrapper';
import IRestTimeEntry from 'types/rest/RestTimeEntry';
import { AxiosInstance } from 'utils/axiosClient';

// There might be more args there might not be it's not documented at all
export interface IConflictRpcArgs<T extends RpcMethod.GET_BY_ORGANIZATION | RpcMethod.GET_BY_MEMBER> {
  method: T;
  range_start: number;
  range_end: number;
}

export interface IMemberConflictRpcArgs extends IConflictRpcArgs<RpcMethod.GET_BY_MEMBER> {
  member_id: string;
}

export type IOrganizationConflictRpcArgs = IConflictRpcArgs<RpcMethod.GET_BY_ORGANIZATION>;

export default function getConflictRpc(client: AxiosInstance) {
  return {
    conflicts: (args: IMemberConflictRpcArgs | IOrganizationConflictRpcArgs, config?: AxiosRequestConfig) => {
      const { method, ...params } = args;
      return client.post<IBusyRpcWrapper<IRestTimeEntry[]>>('/entry-conflict', getRpcParams(method, params), config);
    },
  };
}
